import React from "react";
import Close from '../assets/icons/Close'

const Modal = ({ show, onClose, size = "md", children }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay"  >
      <div
        className={`modal-content modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <button className="close-btn" onClick={onClose}>
            <Close />
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
